import {AbstractControl, AsyncValidatorFn, ValidationErrors} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {inject} from "@angular/core";
import {catchError, of} from "rxjs";
import {map} from "rxjs/operators";
import {isDefined} from "../../../core/util/isDefined";


export function emailInUseValidator(apiPath: string, previousEmail?: string): AsyncValidatorFn {
    const http = inject(HttpClient);
    const debounceTime = 1000;
    let promise: Promise<ValidationErrors|null>;
    let timeout: any = null;

    const loader = (email: string ) => {
        if(timeout){ clearTimeout(timeout); }
        promise = new Promise<ValidationErrors>((resolve) => {
            timeout = setTimeout(() => {
                http.post(`${apiPath}`, email).pipe(
                    map((response: any) => (response ? {emailExists: true} : null)),
                    catchError(() => of(null))
                ).subscribe(resolve)
            }, debounceTime)
        })
    };

    return (control: AbstractControl): Promise<ValidationErrors | null> => {
        if( !isDefined(control.value) || control.value === '' || control.value === previousEmail ){ return Promise.resolve(null); }
        loader(control.value);
        return promise;
    };
}